module.exports = __webpack_public_path__ + "img/1791992473368.317e7396.png";